import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-data-table.data-table-label',
		defaultMessage: 'Data table',
		description: 'Data table subtype label',
	},
});
